<template>
  <div class="information" id="information">
    <div class="information-box" @click="toNext('NoticeHome')">
      <img src="@/assets/img/information/information_icon_2.png" />
      <span>通知公告</span>
    </div>
    <div class="information-box" @click="toNext('PoliciesHome')">
      <img src="@/assets/img/information/information_icon_1.png" />
      <span>政策法规</span>
    </div>
    <div class="information-box" @click="toNext('WorkGuideHome')">
      <img src="@/assets/img/information/information_icon_3.png" />
      <span>办事指南</span>
    </div>
  </div>
</template>

<script>
import moduleMixins from '@/mixins/moduleMixins'

export default {
  name: 'InformationHome',
  mixins: [moduleMixins],
  data() {
    return {
      title: ''
    }
  },
  computed: {
    navTitle() {
      return this.title
    }
  },
  methods: {
    toNext(val) {
      this.$router.push({name: val})
    }
  },
  mounted() {
    this.title = this.$route.query.title
  }
}
</script>

<style lang="scss" scoped>
.information {
  padding: 15px;
  .information-box {
    display: flex;
    margin-bottom: 15px;
    background: #fff;
    padding: 10px;
    align-items: center;
    box-shadow: 0px 2px 5px 0px rgba(124, 130, 140, 0.2);
    border-radius: 5px;
    img {
      width: 46px;
      height: 46px;
      margin-left: 25px;
      margin-top: 15px;
      margin-bottom: 15px;
    }
    span {
      padding-left: 35px;
      font-size: 18px;
      font-weight: 500;
      color: #333333;
      line-height: 21px;
    }
  }
}
</style>
